import TextLayoverImg from "../components/TextLayoverImg";
import Collapsible from "../components/Collapsible";
import faqs from "../components/faqs";
import BrandStory from "../components/BrandStory";
import MasterCardCategories from "../components/MasterCardCategories";
import MasterCardReview from "../components/MasterCardReview";

const Home = () => {

    return (
        <>
        <TextLayoverImg to="allproducts"/>

        <BrandStory />
        <MasterCardCategories />
       
        <MasterCardReview />

        <section class="cards-section">
            <div class="container">
                 <h2 class="section-title">FAQ</h2>
                 {
                    faqs.map((faq) => {
                        console.log(faq);
                        return <Collapsible question={faq.question} answer={faq.answer}/>
                    })
                }
            </div>
        </section>

        </>
    );
}

export default Home;